
<div [formGroup]="genericListFormGroup">
  <div class="form-group">
    <label for="{{baseId}}-id" translate>ID</label>
    <input id="{{baseId}}-id"
            class="form-control"
            [ngClass]="{'error': externalIdControl.invalid && form.submitted}"
            type="text"
            maxlength="25"
            formControlName="externalIdControl"
            />
    <ng-container *ngIf="form.submitted && externalIdControl && externalIdControl.hasError('maxlength')">
      <div id="{{baseId}}-warning-text-external-id-maxlength" class="incorrect-input" translate>
        External Id must be 25 characters or less.
      </div>
    </ng-container>
  </div>

  <div class="form-group">
    <label for="{{baseId}}-name" translate>Name</label>
    <input id="{{baseId}}-name"
            class="form-control"
            [ngClass]="{'error': nameControl.invalid && form.submitted}"
            type="text"
            maxlength="50"
            formControlName="nameControl"
            />
    <ng-container *ngIf="form.submitted && nameControl && nameControl.hasError('maxlength')">
      <div id="{{baseId}}-warning-text-name-maxlength" class="incorrect-input" translate>
        Name must be 50 characters or less.
      </div>
    </ng-container>
    <ng-container *ngIf="form.submitted && nameControl && nameControl.hasError('required')">
      <div id="{{baseId}}-warning-text-name-required" class="incorrect-input" translate>
        Name is a required input.
      </div>
    </ng-container>
  </div>
  <div class="form-group full-control">
    <label for="{{baseId}}-notes" translate>Notes</label>
    <textarea class="form-control"
              [ngClass]="{'error': notesControl.invalid && form.submitted}"
              id="{{baseId}}-notes"
              formControlName="notesControl"
              rows="3">
    </textarea>
  </div>
  <div class="checkbox-group">
    <mat-checkbox id="{{baseId}}-inactive-checkbox"
                  formControlName="inactiveControl"
                  translate>Inactive
    </mat-checkbox>
    <mat-checkbox id="{{baseId}}-user-defined-checkbox"
                  formControlName="userDefinedControl"
                  translate>User Defined
    </mat-checkbox>
  </div>
</div>
